var getValueIf = function getValueIf(condition, value, defaultValue) {
  return condition ? value : defaultValue;
};

export { getValueIf };
//# sourceMappingURL=getValueIf.js.map
